import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Layout } from '../components/Layout/Layout';
import { LogoBox } from '../components/common/LogoBox';
import { RootState } from '../store/rootReducer';
import { CardPayment } from '../components/common/CardPayment.tsx';
import { Container } from './PaymentPage.styled.ts';
import { usePayment } from '../hooks/usePayment.ts';
import { Modal } from '../components/common/Modal.tsx';
import { PaymentTestPanel } from '../components/common/PaymentTestPanel.tsx';
import { useEffect, useRef } from 'react';

export function PaymentPage() {
  const { t } = useTranslation();
  const photoCount = useSelector((state: RootState) => state.photo.photoCount);
  const block = useSelector((state: RootState) => state.block.block);
  const selectedThemeId = useSelector((state: RootState) => state.theme.selectedThemeId);

  const theme = selectedThemeId
    ? block.themes.find((t) => t.id === selectedThemeId) || block.themes[0]
    : block.themes[0];

  const { qrPrice, printPrice } = theme;

  const amount = photoCount === 0 ? qrPrice : photoCount * printPrice;
  const paymentInitiatedRef = useRef(false);

  const {
    isPaymentCompleted,
    error,
    handleError,
    requestKisPayment,
    failureCount,
    handleTestApproval,
  } = usePayment({
    amount,
  });

  useEffect(() => {
    if (!paymentInitiatedRef.current) {
      paymentInitiatedRef.current = true;
      requestKisPayment();
    }
  }, [requestKisPayment]);

  return (
    <Layout>
      <Container>
        <LogoBox />
        <CardPayment isCompleted={isPaymentCompleted} />
        <PaymentTestPanel onApprove={handleTestApproval} amount={amount} />
      </Container>
      {error && (
        <Modal
          title={t('payment.title')}
          time={5}
          errorMessage={t('payment.error', { error, count: failureCount })}
          onTimeEnd={handleError}
          customNavigationText={t('payment.return')}
        />
      )}
    </Layout>
  );
}
